import { createFileRoute } from '@tanstack/react-router'
import { planPointSearchSchema } from '@/features/programs/filter-plan-points/model/planPointSearch'
import { ProgramDetailPage } from '@/pages/program-detail/ui/ProgramDetailPage'

export const Route = createFileRoute('/programs_/$programId/plan-points')({
  validateSearch: planPointSearchSchema,
  component: ProgramDetailPage,
})
